// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"1411":"9a3ba646e0060601","3969":"a01402fd9263aafe","5223":"9df559a00ea1cbc2","8445":"506568f878839125"}[chunkId] + ".js";
};